"use strict";

$(function () {
  $("#intro-readmore").on('click', function (e) {
    e.preventDefault();
    $("#intro-part2").slideDown(500);
    $(e.currentTarget).remove();
  });
  $('.gallery .img').on('click', function (e) {
    $(e.currentTarget).toggleClass('big');
  });
  $('.gallery-actions .resize-full').on('click', function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().parent().find('.gallery .img').addClass('big');
  });
  $('.gallery-actions .resize-small').on('click', function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().parent().find('.gallery .img').removeClass('big');
  });
  $(".toc-chapter-title a").on('click', function (e) {
    e.preventDefault();
    window.location = $(e.currentTarget).attr('href');
    $(".book-chapter").hide();
    $($(e.currentTarget).data("target")).show();
    $($(e.currentTarget).data("target")).find('.book-chapter').show();
    $($(e.currentTarget).data("target")).parents('.book-chapter').show();
    $('.toc-chapter-title a').removeClass("active");
    $(e.currentTarget).addClass("active");
    $('.pdf-link-wrapper').show();
    $(".pdf-viewer").remove();
    $("html, body").animate({
      scrollTop: 0
    }, 500);
  });
  $(".toc-section a").on('click', function (e) {
    $(".book-chapter").hide();
    $($(e.currentTarget).data("chapter-target")).show();
    $($(e.currentTarget).data("target")).find('.book-chapter').show();
    $($(e.currentTarget).data("target")).parents('.book-chapter').show();
    $('.toc-chapter-title a').removeClass("active");
    $(e.currentTarget).closest(".toc-chapter").children(".toc-chapter-title").find('a').addClass("active");
    $('.pdf-link-wrapper').show();
    $(".pdf-viewer").remove();
    $('html, body').animate({
      scrollTop: $($(e.currentTarget).data("target")).offset().top - 40
    }, 500);
  });
  $(".book-chapter a[data-target]").on('click', function (e) {
    e.preventDefault();
    $('.toc-wrapper a[data-target="' + $(e.currentTarget).data('target') + '"]').first().click();
  });
  $(".navbar-lang a").on('click', function (e) {
    e.preventDefault();
    document.location.href = $(e.currentTarget).attr('href') + window.location.hash;
  });
  $("a.pdf-link").on('click', function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().parent().append('<div class="pdf-viewer"><div><a class="media" href="' + $(e.currentTarget).attr('href') + '"></a></div><a href="#" class="pdf-hide">' + $(e.currentTarget).data('label-hide') + '</a><a href="#" class="pdf-fullscreen" style="float:right;">' + $(e.currentTarget).data('label-fullscreen') + '</a></div>');
    $('a.media').media({
      width: "100%"
    });
    $(e.currentTarget).parents('.pdf-link-wrapper').hide();
  });
  $(document).on("click", "a.pdf-hide", function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().parent().find('.pdf-link-wrapper').show();
    $(e.currentTarget).parent().parent().find(".pdf-viewer").remove();
  });
  $(document).on("click", "a.pdf-fullscreen", function (e) {
    e.preventDefault();
    $(e.currentTarget).parent().parent().find('iframe').addClass("fullscreen-mode");
    $('.fullscreen-close').show();
  });
  $(document).on("keyup", function (e) {
    if (e.which == 27) {
      $('.fullscreen-close a').trigger('click');
    }
  });
  $(document).on("click", ".fullscreen-close a", function (e) {
    e.preventDefault();
    $('iframe').removeClass("fullscreen-mode");
    $('.fullscreen-close').hide();
  });
  var hash = $(location).attr('hash');
  if (hash != '') {
    $('.book-chapter').hide();
    $(hash).show();
    $(hash).find('.book-chapter').show();
    $(hash).parents('.book-chapter').show();
    $('html,body').animate({
      scrollTop: target.offset().top - 40
    }, 500);
  }
});